const KEY = "ccs_recent";

export function recordView(slug) {
  if (!slug) return;
  let list = [];
  try {
    list = JSON.parse(localStorage.getItem(KEY)) || [];
  } catch {
    list = [];
  }
  list = [slug, ...list.filter((s) => s !== slug)].slice(0, 12);
  localStorage.setItem(KEY, JSON.stringify(list));
}

export function getRecent() {
  try {
    return JSON.parse(localStorage.getItem(KEY)) || [];
  } catch {
    return [];
  }
}
